package org.example.project.enginevertrieb

import androidx.compose.runtime.Composable
import kotlinx.browser.window

@Composable
fun AkquiseEinstellungen(node: String = "SYS") {
    FlowProfileSettings(node, onClose = {
        window.location.hash = window.location.hash.substringBefore('?') + "?screen=" +
            (if (node == "SYS") "SYSVertriebsDashboard" else "VertriebsDashboard")
    }, rollenKey = "AkquiseEinstellungen")
}
